import './ios-polyfills.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { initHyperDX } from './utils/hyperdx';

// HyperDX disabled: collector ingest returns 403 (nginx egress IP not whitelisted
// behind VPN), which causes failing/buffered telemetry. Re-enable once ingest works.
// Initialize HyperDX observability as early as possible (before app render) so
// console logs, network calls and traces are captured from startup.
// initHyperDX();

// ======== MONKEY-PATCH FETCH TO BLOCK COUNTLY ========
const originalFetch = window.fetch;
window.fetch = async (url, ...args) => {
  if (typeof url === 'string' && url.includes('innovatrics.count.ly')) {
    console.log('[Analytics Blocked] Countly request prevented:', url);
    return Promise.resolve(new Response(null, { status: 204 })); // Return empty success
  }
  return originalFetch(url, ...args);
};


const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

console.log("Environment Base URL:", process.env.REACT_APP_BASE_URL);

window.addEventListener('resize', setVh);
setVh(); // Initial call to set the --vh property

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

